import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MarkantElementsModule } from '@markant/elements-angular';
import { TranslocoPipe } from '@jsverse/transloco';
import { CartridgeRoleAssignmentFlow, CartridgeWithSelectableRoles } from '@markant-platform/authorizer/model';

@Component({
  selector: 'markant-platform-ui-cartridge-role-limit',
  standalone: true,
  imports: [MarkantElementsModule, TranslocoPipe],
  templateUrl: './ui-cartridge-role-limit.component.html',
  styleUrl: './ui-cartridge-role-limit.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiCartridgeRoleLimitComponent implements OnInit {
  @Input({ required: true }) cartridgeRole!: CartridgeWithSelectableRoles;
  @Input({ required: true }) flow!: CartridgeRoleAssignmentFlow;

  protected readonly cartridgeRoleAssignmentFlow = CartridgeRoleAssignmentFlow;
  protected slotsAlreadyAssignedForUser = false;
  protected slotsAlreadyAssignedForGroup = false;
  protected slotsAlreadyInUseTranslationKey = '';

  ngOnInit(): void {
    this.slotsAlreadyAssignedForUser = this.cartridgeRole.limits?.userHasAlreadyAssignmentForVariant ?? false;
    this.slotsAlreadyAssignedForGroup = (this.cartridgeRole.limits?.usedSlotsByGroup ?? -1) > 0;
    if (this.slotsAlreadyAssignedForUser) {
      this.slotsAlreadyInUseTranslationKey = 'slotsAlreadyInUseForUser';
    } else if (this.slotsAlreadyAssignedForGroup) {
      this.slotsAlreadyInUseTranslationKey = 'slotsAlreadyInUseForGroup';
    }
  }
}
